module.exports = __webpack_public_path__ + "9a079f6904d9dc0ab65efbc1396c8756.png";